export enum EClubInfoPage {
	STADIUM_HISTORY = "STADIUM_HISTORY",
	SUPPORTERS = "SUPPORTERS",
	COLORS_AND_SLOGANS = "COLORS_AND_SLOGANS",
	REGION = "REGION",
}
